import { createSlice } from "@reduxjs/toolkit";
import { GetOpenTasks } from "./BasicInfoCardActions";

interface AgentTask {
  id: string;
  customerName: string;
  policyNumber: string;
  dueDate: string;
  dueTime: string;
  taskName: string;
  description: string;
  providerId: string;
  priority: string;
  status: string;
  carrier: string;
  system: string;
  policyId: string;
  lobCode: string;
}

interface TaskData {
  taskCount: number;
  agentTasks: AgentTask[];
}

interface TaskState {
  openTasksData: TaskData | null;
}

const initialState: TaskState = {
  openTasksData: {
    taskCount: 0,
    agentTasks: [],
  },
};

const openTaksSlice = createSlice({
  name: "openTasks",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetOpenTasks.fulfilled, (state, { payload }) => {
      state.openTasksData = payload.data;
    });
  },
});

export default openTaksSlice.reducer;
